import { extendObservable } from "mobx"


export class AlertPopupStore {
  constructor() {
    this.confirmFunc = function(){}//Do nothing
    extendObservable(this, {
       show : false,
       title:'',
       message :'',
       level : 'info',
       buttonTitle :''
    })
  }

  confirm(message,buttonTitle,confirmFunc){
    this.show = true
    this.title = 'ยืนยัน'
    this.level  = 'default'
    this.message = message
    this.buttonTitle = buttonTitle
    this.confirmFunc = confirmFunc
  }

  onConfirm(){
    this.confirmFunc()
    this.hide()
  }

  info(message,title){
    this.show = true
    this.title = typeof title !=='undefined'?title:'ข้อมูลทั่วไป'
    this.level  = 'default'
    this.message = message
  }

  warn(message,title){
    this.show = true
    this.title = typeof title !=='undefined'?title:'แจ้งเตือน'
    this.level  = 'warning'
    this.message = message
  }

  error(message,title){
    this.show = true
    this.title = typeof title !=='undefined'?title:'เกิดข้อผิดพลาด'
    this.level  = 'danger'
    this.message = message
  }

  showPopup(message,title,level){
    this.show = true
    this.title = typeof title !=='undefined'?title:'แจ้งเตือน'
    this.level  = typeof level !=='undefined'?level:this.level
    this.message = message
  }

  hide(){
    this.show = false
    this.title = ''
    this.message = ''
    this.level = 'info'
    this.buttonTitle = ''
    this.confirmFunc  = function(){}
  }
}

export default new AlertPopupStore()



// WEBPACK FOOTER //
// ./src/component/element/AlertPopupStore.js